import { combineReducers } from 'redux';

import country from './country/reducer';

export default combineReducers({
  country,
});
